import PropTypes from 'prop-types';
import React from "react";
import Loading from "../../component/Loading/Loading";
import Notify from "../../services/Notify";
import ProductTypeService from "../ProductTypeService";
import Table from "../../component/Table/Table";
import {FormGroup} from "react-bootstrap";

class ProductTypeParamsTable extends React.Component {

  service = new ProductTypeService();

  constructor(props) {
    super(props);
    this.state = {params: props.defaultValue || {}};
  }

  componentWillMount() {
    this.setState({loading: true});
    this.service.findAllParams().then(
        data => this.setState({loading: false, entity: data.content}),
        error => this.setState({loading: false, message: 'Error'})
            && Notify.error('Falha o buscar parâmetro!', error)
    )
  }

  onChange(event) {

    const {entity} = this.state;
    const {setValue} = this.props;
    const params = {};

    entity.forEach(({name}) => {
      if (this[name]) {
        params[name] = this[name].value;
      }
    });

    setValue && setValue(params);
    console.log(params);
  }

  render() {
    const {loading, entity, params} = this.state;

    if (loading) {
      return <Loading/>;
    }

    return (
        <div className="table-responsive no-padding">
          <Table>
            <thead>
            <tr>
              <th>Nome</th>
              <th>Valor</th>
            </tr>
            </thead>
            <tbody>
            {this.renderTableBody(params, entity)}
            </tbody>
          </Table>
        </div>
    );
  }

  renderTableBody(params, entity) {
    return entity.map(({name, id}) => <tr key={id}>
      <td>
        {name}
      </td>
      <td>
        <FormGroup>
          <input type="text" className="form-control"
                 name={params[name]}
                 ref={value => this[name] = value}
                 onChange={(event) => this.onChange(event)}
                 defaultValue={params[name]}/>
        </FormGroup>
      </td>
    </tr>);
  }
}

ProductTypeParamsTable.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.object,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default ProductTypeParamsTable;



// WEBPACK FOOTER //
// ./src/productType/component/ProductTypeParamsTable.js